/**
 * Retorna el locale Intl correspondiente al país operativo.
 * Chile → "es-CL" (miles=punto, decimal=coma)
 * Perú  → "es-PE" (miles=coma, decimal=punto)
 * Cualquier otro valor → "es-CL" (fallback seguro)
 * Uruguay y cualquier país inactivo NO tienen locale propio.
 */
const LOCALE_MAP = {
  Chile: "es-CL",
  Perú: "es-PE",
};

export const getLocale = (pais) => LOCALE_MAP[pais] || "es-CL";
